<template>
  <q-markup-table flat cellpadding="0" cellspacing="0" class="full-width rounded-borders-10"
                  v-if="plan">
    <tbody>
    <tr>
      <td>Month</td>
      <td v-for="usage in historical_usage" :class="{'bg-blue-1': selected(usage), 'cursor-pointer': usage.usage}"
          class="text-blue-grey-5" @click="select_usage(usage.usage)">
        <div :class="{'text-accent': selected(usage)}"> {{ usage.short_month }}</div>
      </td>
      <td>Total</td>
    </tr>
    <tr>
      <td>Usage<br> (kWh)</td>
      <td v-for="usage in historical_usage" :class="{'bg-blue-1': selected(usage), 'cursor-pointer': usage.usage}"
          class="text-blue-grey-5" @click="select_usage(usage.usage)">
        <div :class="{'text-accent': selected(usage)}">{{ usage.usage }}</div>
      </td>
      <td>{{ plan.total_usage }}</td>
    </tr>
    <tr>
      <td>Bill</td>
      <td v-for="usage in historical_usage" :class="{'bg-blue-1': selected(usage), 'cursor-pointer': usage.usage}"
          class="text-blue-grey-5" @click="select_usage(usage.usage)">
        <div :class="{'text-accent': selected(usage)}" v-if="plan[`display_pricing_${usage.usage}`]">
          ${{ format_dollar_amount(plan[`display_pricing_${usage.usage}`]?.total) }}
        </div>
      </td>
      <td>${{ format_dollar_amount(plan.total_cost) }}</td>
    </tr>
    <tr>
      <td>per kWh</td>
      <td v-for="usage in historical_usage" :class="{'bg-blue-1': selected(usage), 'cursor-pointer': usage.usage}"
          class="text-blue-grey-5" @click="select_usage(usage.usage)">
        <div :class="{'text-accent': selected(usage)}" v-if="plan[`display_pricing_${usage.usage}`]">
          {{ plan[`display_pricing_${usage.usage}`]?.avg_cents.toFixed(1) }}¢
        </div>
      </td>
      <td>{{ plan.total_average }}¢</td>
    </tr>
    </tbody>
  </q-markup-table>
</template>

<script>
import UsageFilters from "src/composables/UsageFilters";
import { computed, onMounted } from "vue";
import Plans from "src/composables/Plans";
import Utilities from "src/composables/Utilities";

export default {
  name: "HistoricalUsageSelector",
  props: {
    plan: {
      type: Object,
      required: true
    },
    modelValue: {
      type: Number
    }
  },
  setup(props, { emit }) {

    const { historical_usage } = UsageFilters();
    const { calculate_plan_for_usage } = Plans();
    const { format_dollar_amount } = Utilities();

    const selected = usage => selected_usage.value == usage?.usage;

    const selected_usage = computed({
      get: () => props.modelValue,
      set: (val) => emit('update:modelValue', val)
    })

    onMounted(() => {
      selected_usage.value = historical_usage.value.find(x => x.usage)?.usage || 500;
    })

    const select_usage = async function (val) {
      if (val) {
        val = parseInt(val);
        if (!props.plan[`display_pricing_${val}`]) {
          const pricing = await calculate_plan_for_usage({ plan_id: props.plan._id, usage: val });
          props.plan[`display_pricing_${val}`] = pricing;
        }
        selected_usage.value = val;
      }
    }

    return {
      selected,
      select_usage,
      historical_usage,
      format_dollar_amount
    }
  }
}
</script>

<style scoped>

</style>
